import { render, staticRenderFns } from "./RelogioPonto.vue?vue&type=template&id=090b7de4&"
import script from "./RelogioPonto.vue?vue&type=script&lang=js&"
export * from "./RelogioPonto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports